module.exports = __webpack_public_path__ + "img/login1.66a29141.png";